$(document).on('ready', () => {
  $('.box-location').on('touchstart', event => {
    const $box = $(event.currentTarget);

    $box
      .toggleClass('box-location--hovered')
      .parent()
      .siblings()
      .find('.box-location')
      .removeClass('box-location--hovered');
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/locations.js